<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">REGRAS DE ACESSO</span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblRegrasAcesso"
                    :itens="regrasAcesso"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button
                                variant="success"
                                @click="inserirRegraAcesso()"
                                v-if="$temAcessoView('CTRLACS-RA-01')"
                                >Inserir Regra de Acesso</b-button
                            >
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('CTRLACS-RA-02')"
                            ><i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="
                                    detalharRegraAcesso(data.regraAcessoId)
                                "
                            ></i
                        ></span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import RegrasAcessoServicos from '../regrasacesso/RegrasAcessoServicos'

export default {
    data() {
        return {
            regrasAcesso: [],
            campos: [
                {
                    key: 'codRegraAcesso',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricaoRegraAcesso',
                    label: 'Descrição da regra de acesso',
                    sortable: true,
                    filterable: true
                },
                // {
                //   key: 'caFlag',
                //   label: 'Nível'
                // },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterRegrasAcesso() {
            this.$store.dispatch('addRequest')
            RegrasAcessoServicos.obterTodas().then(response => {
                if (response) {
                    if (response.success) {
                        this.regrasAcesso = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirRegraAcesso() {
            this.$router.push({ name: 'RegrasAcesso_Inserir' })
        },

        detalharRegraAcesso(id) {
            this.$router.push({
                name: 'RegrasAcesso_Detalhar',
                params: {
                    id: id
                }
            })
        }
    },

    created() {
        this.obterRegrasAcesso()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'RegrasAcesso'
        }
    },

    watch: {
        $route(to, from) {
            if (to.name === 'RegrasAcesso') {
                if (this.$store.getters.recarregar) {
                    this.obterRegrasAcesso()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    }
}
</script>
